import script from "./WallInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WallInfo.vue?vue&type=script&setup=true&lang=js"

import "./WallInfo.vue?vue&type=style&index=0&id=6adddb7a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6adddb7a"]])

export default __exports__